import { CreateDrawerFormProps, FormDrawerContent, I18nFormDrawer, TextField, isEmail } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { IDeletionRequestFormState } from "../shared/types";

const useValidate = () => {
	const { t } = useTranslation();

	return (values: IDeletionRequestFormState) => {
		const errors: { [K in keyof IDeletionRequestFormState]?: any } = {};

		if (!isEmail(values.email)) {
			errors.email = t("Invalid email address");
		}

		return errors;
	};
};

export const DeletionRequestCreateDrawer: FC<CreateDrawerFormProps<IDeletionRequestFormState>> = (props) => {
	const { t } = useTranslation();
	const validate = useValidate();
	const initialValues = {
		email: "",
	};

	return (
		<I18nFormDrawer
			{...props}
			initialValues={initialValues}
			title={t("Add deletion request")}
			validate={validate}
			renderForm={(props) => (
				<FormDrawerContent {...props}>
					<TextField name="email" label={t("Email")} required />
				</FormDrawerContent>
			)}
		/>
	);
};
